import { createTRPCContext } from '@trpc/tanstack-react-query';

import type { AppRouter } from '@cadstrom/backend/trpc';

export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>();
